import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
import { FilterVariables, FilterArgs } from './queryVariables/filters';
/**
 * Resource regulaminów
 *
 * @export
 * @class TermsResource
 * @extends {EntityResource<Terms>}
 */
export class TermsResource extends EntityResource {
    constructor() {
        super({
            entityName: 'terms',
            listName: 'termsList'
        });
        this.getFields = {
            id: true,
            name: true,
            order: true,
            type: true,
            profileType: true,
            required: true,
            start: true,
            end: true,
            content: true,
            mediaId: true
        };
        this.listFields = {
            id: true,
            name: true,
            start: true,
            end: true,
            type: true,
            profileType: true,
            consents: {
                accepted: true
            }
        };
        this.addVariables = { terms: 'TermsInput!' };
        this.addArgs = { terms: new VariableType('terms') };
        this.updateVariables = { id: 'Int!', terms: 'TermsInput!' };
        this.updateArgs = {
            id: new VariableType('id'),
            terms: new VariableType('terms')
        };
        this.listVariables = FilterVariables;
        this.listArgs = FilterArgs;
    }
    /**
     * Pobieranie aktualnych regulaminów
     *
     * @param {string} profileType
     * @returns {Promise<Terms[]>}
     * @memberof TermsResource
     */
    async termsCurrent(profileType, required, type) {
        const query = this.prepareOptions({
            query: {
                __variables: { profileType: 'ProfileType!', required: 'Boolean', type: 'TermType' },
                termsCurrent: {
                    __args: {
                        profileType: new VariableType('profileType'),
                        required: new VariableType('required'),
                        type: new VariableType('type')
                    },
                    id: true,
                    name: true,
                    content: true,
                    order: true,
                    required: true,
                    mediaId: true,
                    start: true
                }
            }
        });
        return this.query({
            query,
            variables: { profileType, required, type }
        }, 'termsCurrent');
    }
}
export const termsResource = new TermsResource();
//# sourceMappingURL=terms.resource.js.map